import axios from 'axios';
import { getErrorMessage } from '../util/ErrorUtils';

export const fetchMyLibraryUserCasesAPI = async (payload) => {
    const data = {
        ...payload,
        pageNo: payload.pageNo - 1
    };

    return await axios.post(`/api/v1/usercases/my-library`, payload.userCaseRequest, {
        params: {
            ...data
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error }
        })
}

export const fetchAllUserCasesAPI = async (payload) => {
    const data = {
        ...payload,
        pageNo: payload.pageNo - 1
    };


    return await axios.post(`/api/v1/usercases/all-cases`, payload.userCaseRequest, {
        params: {
            ...data
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error }
        })
}

export const fetchNewUserCasesAPI = async () => {
    return await axios.get(`/api/v1/user-cases/new-cases`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error }
        })
}


export const addReportToMyLibraryAPI = async (data) => {

    return await axios.post(`/api/v1/user-case`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const deleteUserCaseAPI = async (caseId) => {
    return axios.delete(`/api/v1/usercases/${caseId}`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };

        })
}

export const fetchUserCasesByReportIdAPI = async (reportId) => {
    return await axios.get(`/api/v1/user-cases/visit/${reportId}`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error }
        })
}

export const updateMyLibraryUserCaseAPI = async (data) => {
    return await axios.post(`/api/v1/user-case/${data.caseId}`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchReportUserCaseAPI = async (reportId) => {

    return await axios.get(`/api/v1/user-case/visit/${reportId}`, {
        params: {
            'reportId': reportId
        }
    })
        .then(function (response) {
            return { success: true, data: response.data || null }
        }).catch(function (error) {
            const responseData = error && error.response ? error.response.data : null;
            const errorText = typeof responseData === 'string' ? responseData : JSON.stringify(responseData || {});
            if (error && error.response && (error.response.status === 404 || errorText.indexOf('User case not found') > -1)) {
                return { success: true, data: null }
            }
            return { success: false, error: getErrorMessage(error) }
        })
}

export const getCaseStudyAPI = async (caseId) => {
    return await axios.get(`/api/v1/user-case/${caseId}/study`)
        .then(function (response) {
            const { orthancServerUrl, body } = response.data;
            const study = JSON.parse(body);
            return { success: true, data: { study, orthancServerUrl } };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}
